import React, {useState,useEffect} from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import SLoader from '../Component/Loading/SigninLoader';
import Navbar from '../Component/Navbar';
import Footer from '../Pages/FooterSup';
import { useCookies } from 'react-cookie';
import Error from '../Component/Error'
import { MdOutlineVisibility, MdOutlineVisibilityOff } from "react-icons/md";

const theme = createTheme();

export default function Loginpg() {
  const [loading, setLoading] = useState(false)
  const [currentState, setCurrentState] = useState("")
  const [loaderror, setLoaderror] = useState(false)
  const [visible, setVisible] = useState(true)
  const navigate = useNavigate()
  const [cookies, setCookie] = useCookies(['Token']);

  useEffect(()=>{
    setCurrentState("0");
  },[])
  
  console.log(cookies)

  const handleSubmit = async (e) => {
    try{
        e.preventDefault();
        setLoading(true)
        const data = new FormData(e.currentTarget);
        // eslint-disable-next-line no-console
        localStorage.setItem('Email', data.get('email'))
        localStorage.setItem('Password', data.get('password'))
        localStorage.setItem('Status', 'true')
        const obj = {
          email: data.get('email'),
          password: data.get('password'),
        }
    // console.log(obj);
    // axios.post(`http://localhost:5000/login`, obj).then((response) => {
        await axios.post(`https://sabre-ng-e-certificate.herokuapp.com/login`, obj).then((response) => {
          if(response.data.code === 200){
              // console.log(response.data);
              setLoading(true)
              navigate ('/documentupload')
              setCookie('Token', response.data.token, { path: '/'});
            }
        });

      }catch(e){
        // console.log('Error is Here')
        setLoading(false)
        setLoaderror(true)
      }
  };

  const handleClose = (closeStatus) =>{
    // console.log(`closeStatus : ${closeStatus}`)
    setLoaderror(false)
  }

  const handleVisIcon = () =>{
    setVisible(!visible)
  }

  return (
    <>
    <Navbar defaultState={currentState}/>
    {loading ? <SLoader message="Verifying..." /> : <div className='signinContain'>
      <ThemeProvider theme={theme}>
        <Container 
          component="main"
          maxWidth="xs"
         >
          <CssBaseline />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              height: '70vh',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: '#e50000' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Admin Signin Page
            </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                sx={{ backgroundColor:"white" }}
              />
              <span className='pswdfield'>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type={visible ? "password" : "text"}
                  id="password"
                  autoComplete="current-password"
                  sx={{ backgroundColor:"white" }}
                />
                {visible ? <MdOutlineVisibility id="visbIcon" onClick={handleVisIcon} /> : <MdOutlineVisibilityOff id="visbIcon" onClick={handleVisIcon}/>}
              </span>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2, backgroundColor:'#e50000', '&:hover': {
                  background: "#f00"}}}
              >
                Sign In
              </Button>
            </Box>
          </Box>
        </Container>
      </ThemeProvider>
    </div>}
    {loaderror && <Error closeOverlay={handleClose} message={"Invalid Username or Password"}/>}
    <Footer />
    </>  
  );
}